function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    //     document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }
  // here
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateProductTitle();
    this.udpateNotice();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShippingInfo(this.currentVariant.id);
    }
  }

  updateShippingInfo(id){
    let shippingElements = document.querySelectorAll('.shipping-wrapper');

    if(shippingElements.length){
      let activeShippingElement = document.querySelector(`.shipping-wrapper[data-variant-id="${id}"]`);

      shippingElements.forEach((el)=>{
        el.classList.remove('show');
      })

      if(activeShippingElement){
        activeShippingElement.classList.add('show');
      }

    }
  }

  udpateNotice() {
    const originalText = `
            <h4 class="shipping-info-para shipping-title">Ship in 12-14 weeks
              <div class="shipping-tooltip">
                <div class="shipping-tooltip__icon">
                 <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" fill="none">
                              <path d="M45 0C36.0998 0 27.3996 2.6392 19.9993 7.58387C12.5991 12.5285 6.83137 19.5566 3.42542 27.7792C0.0194788 36.0019 -0.871671 45.0499 0.864664 53.7791C2.601 62.5082 6.88683 70.5264 13.1802 76.8198C19.4736 83.1132 27.4918 87.399 36.2209 89.1353C44.9501 90.8717 53.9981 89.9805 62.2208 86.5746C70.4434 83.1686 77.4715 77.4009 82.4161 70.0007C87.3608 62.6005 90 53.9002 90 45C89.9866 33.0694 85.2413 21.6312 76.8051 13.1949C68.3688 4.7587 56.9306 0.0133558 45 0ZM45 84C37.2865 84 29.7463 81.7127 23.3328 77.4273C16.9192 73.1419 11.9205 67.051 8.9687 59.9247C6.01688 52.7983 5.24455 44.9567 6.74938 37.3915C8.2542 29.8262 11.9686 22.8771 17.4228 17.4228C22.8771 11.9686 29.8262 8.2542 37.3915 6.74937C44.9567 5.24455 52.7983 6.01688 59.9247 8.9687C67.051 11.9205 73.1419 16.9192 77.4273 23.3328C81.7127 29.7463 84 37.2865 84 45C83.9884 55.3399 79.8757 65.2529 72.5643 72.5643C65.2529 79.8757 55.3399 83.9884 45 84Z" fill="black"/>
                              <path d="M45 36.3191C44.4747 36.3191 43.9546 36.4225 43.4693 36.6236C42.9839 36.8246 42.543 37.1192 42.1716 37.4906C41.8001 37.8621 41.5055 38.303 41.3045 38.7883C41.1034 39.2737 41 39.7938 41 40.3191V65.4255C41 66.4863 41.4214 67.5038 42.1716 68.2539C42.9217 69.0041 43.9391 69.4255 45 69.4255C46.0609 69.4255 47.0783 69.0041 47.8284 68.2539C48.5786 67.5038 49 66.4863 49 65.4255V40.3191C49 39.7938 48.8966 39.2737 48.6955 38.7883C48.4945 38.303 48.1999 37.8621 47.8284 37.4906C47.457 37.1192 47.0161 36.8246 46.5307 36.6236C46.0454 36.4225 45.5253 36.3191 45 36.3191Z" fill="black"/>
                              <path d="M45 28.5745C47.2091 28.5745 49 26.7836 49 24.5745C49 22.3653 47.2091 20.5745 45 20.5745C42.7909 20.5745 41 22.3653 41 24.5745C41 26.7836 42.7909 28.5745 45 28.5745Z" fill="black"/>
                            </svg>
                  </div>
                  <div class="shipping-tooltip__text">
                    <p>Our furniture items are either ready to ship or made to order. In-stock items ship immediately, typically arriving within 3-5 business days. Custom orders are delivered to our warehouse within 12-14 weeks. Shop our in stock items <a href="https://neuemaison.co/collections/ready-to-ship">HERE</a></p>
                  </div>
                </div>
              </h4>`;

    const noticeText = `
           <h4 class="shipping-info-para shipping-title">Immediate Shipping
              <div class="shipping-tooltip">
                <div class="shipping-tooltip__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" fill="none">
                              <path d="M45 0C36.0998 0 27.3996 2.6392 19.9993 7.58387C12.5991 12.5285 6.83137 19.5566 3.42542 27.7792C0.0194788 36.0019 -0.871671 45.0499 0.864664 53.7791C2.601 62.5082 6.88683 70.5264 13.1802 76.8198C19.4736 83.1132 27.4918 87.399 36.2209 89.1353C44.9501 90.8717 53.9981 89.9805 62.2208 86.5746C70.4434 83.1686 77.4715 77.4009 82.4161 70.0007C87.3608 62.6005 90 53.9002 90 45C89.9866 33.0694 85.2413 21.6312 76.8051 13.1949C68.3688 4.7587 56.9306 0.0133558 45 0ZM45 84C37.2865 84 29.7463 81.7127 23.3328 77.4273C16.9192 73.1419 11.9205 67.051 8.9687 59.9247C6.01688 52.7983 5.24455 44.9567 6.74938 37.3915C8.2542 29.8262 11.9686 22.8771 17.4228 17.4228C22.8771 11.9686 29.8262 8.2542 37.3915 6.74937C44.9567 5.24455 52.7983 6.01688 59.9247 8.9687C67.051 11.9205 73.1419 16.9192 77.4273 23.3328C81.7127 29.7463 84 37.2865 84 45C83.9884 55.3399 79.8757 65.2529 72.5643 72.5643C65.2529 79.8757 55.3399 83.9884 45 84Z" fill="black"/>
                              <path d="M45 36.3191C44.4747 36.3191 43.9546 36.4225 43.4693 36.6236C42.9839 36.8246 42.543 37.1192 42.1716 37.4906C41.8001 37.8621 41.5055 38.303 41.3045 38.7883C41.1034 39.2737 41 39.7938 41 40.3191V65.4255C41 66.4863 41.4214 67.5038 42.1716 68.2539C42.9217 69.0041 43.9391 69.4255 45 69.4255C46.0609 69.4255 47.0783 69.0041 47.8284 68.2539C48.5786 67.5038 49 66.4863 49 65.4255V40.3191C49 39.7938 48.8966 39.2737 48.6955 38.7883C48.4945 38.303 48.1999 37.8621 47.8284 37.4906C47.457 37.1192 47.0161 36.8246 46.5307 36.6236C46.0454 36.4225 45.5253 36.3191 45 36.3191Z" fill="black"/>
                              <path d="M45 28.5745C47.2091 28.5745 49 26.7836 49 24.5745C49 22.3653 47.2091 20.5745 45 20.5745C42.7909 20.5745 41 22.3653 41 24.5745C41 26.7836 42.7909 28.5745 45 28.5745Z" fill="black"/>
                            </svg>
                  </div>
                  <div class="shipping-tooltip__text">
                    <p>Our furniture items are either ready to ship or made to order. In-stock items ship immediately, typically arriving within 3-5 business days. Custom orders are delivered to our warehouse within 12-14 weeks. Shop our in stock items <a href="https://neuemaison.co/collections/ready-to-ship">HERE</a></p>
                  </div>
                </div>
              </h4>`;

    const idArray = (inStockVariantList || "").split("::").filter(Boolean);
    if (idArray.includes(String(this.currentVariant.id))) {
      $(".shipping-time__container")
        .html(noticeText)
        .closest(".shipping-time")
        .addClass("hide-button");
    } else {
      $(".shipping-time__container")
        .html(originalText)
        .closest(".shipping-time")
        .removeClass("hide-button");
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent
        .querySelector("li.product__media-item")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    ); 
  
    if(document.querySelector('.Your_selection span')){  
      document.querySelector('.Your_selection span').innerText = this.currentVariant.title
    }    
    change_Shipping_text(this.currentVariant.id,this.currentVariant.available)
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  updateProductTitle() {
    let title = document.getElementById("variant_title");
    if (title) {
      title.innerHTML = this.currentVariant.title.toUpperCase();
    }

    return;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

// here
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

function adjustTooltipPosition(tooltip) {
  // const tooltipText = tooltip.querySelector(".shipping-tooltip__text");
  // const tooltipTextRect = tooltipText.getBoundingClientRect();
  // const windowWidth = window.innerWidth;

  // // Reset any previous adjustments
  // tooltipText.style.left = "";
  // tooltipText.style.right = "";

  // const isTooltipOutOfBoundsLeft = tooltipTextRect.left < 0;
  // const isTooltipOutOfBoundsRight = tooltipTextRect.right > windowWidth;

  // if (isTooltipOutOfBoundsLeft || isTooltipOutOfBoundsRight) {
  //   tooltipText.style.left = "50%";
  //   tooltipText.style.transform = "translateX(-50%) translateY(-110%)";
  // }
}

function setupTooltipEvents() {
  const tooltips = document.querySelectorAll(".shipping-tooltip");

  tooltips.forEach((tooltip) => {
    tooltip.addEventListener("mouseover", () => adjustTooltipPosition(tooltip));
    tooltip.addEventListener("touchstart", () =>
      adjustTooltipPosition(tooltip)
    );
  });
}

document.addEventListener("DOMContentLoaded", setupTooltipEvents);



// ADD SHOW/HIDE REVIEWS BUTTON
if(document.body.classList.contains('template-product')){
  function addReviewToggleButton(reviewSection){
    clearInterval(interval);
    let reviewSectionTitle = reviewSection.querySelector('.jdgm-rev-widg__title');
    
    if(reviewSectionTitle){
      let button = document.createElement('button');
      button.classList.add('review-toggle-btn');
      button.innerText = 'Read Reviews';
      button.addEventListener('click',()=>{
        if(button.classList.contains('opened')){
          button.classList.remove('opened');
          hideReviewSection(reviewSection);
          button.innerText = 'Read Reviews';
        }else{
          button.classList.add('opened');
          showReviewSection(reviewSection);
          button.innerText = 'Hide Reviews';
        }
      })

      reviewSectionTitle.insertAdjacentElement('afterend', button);
      hideReviewSection(reviewSection);
    }
  }

  function hideReviewSection(reviewSection){
    if(reviewSection){
     reviewSection.classList.add('hide-review');
    }
   }
 
  function showReviewSection(reviewSection){
     if(reviewSection){
      reviewSection.classList.remove('hide-review');
     }
   }


  let interval = setInterval(()=>{
    let reviewSection = document.getElementById('judgeme_product_reviews');

    if(reviewSection){
      addReviewToggleButton(reviewSection);
    }
  },1000)
}



// ESTIMATED DELIVERY DATE FUNCTIONALITY

document.addEventListener("DOMContentLoaded", function () {
  const shippingElements = document.querySelectorAll(".shipping-wrapper");

  function formatDate(date) {
      const options = { month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
  }

  const today = new Date();

  shippingElements.forEach(element => {
      const minDays = parseInt(element.getAttribute("data-min-days"), 10);
      const maxDays = parseInt(element.getAttribute("data-max-days"), 10);

      if (!isNaN(minDays) && !isNaN(maxDays)) {
          const minDeliveryDate = new Date(today);
          minDeliveryDate.setDate(today.getDate() + minDays);

          const maxDeliveryDate = new Date(today);
          maxDeliveryDate.setDate(today.getDate() + maxDays);

          const formattedMinDate = formatDate(minDeliveryDate);
          const formattedMaxDate = formatDate(maxDeliveryDate);

          element.textContent = `Estimated delivery: ${formattedMinDate} - ${formattedMaxDate}`;
      }
  });
});
async function change_Shipping_text(id,available) {
  const inventry_div = document.querySelector('li.product-inventory__point')
  const inventry_span = document.querySelector('li.product-inventory__point span[data-product-inventory]')
  const plus_icons = document.querySelector('span.icon.icon--inventory.circless.pulse')  
  let varinat_qty = parseInt(document.querySelector(`.variants_inventry[data-id="${id}"]`).getAttribute('data-qty'))
  let ploicy = document.querySelector(`.variants_inventry[data-id="${id}"]`).getAttribute('data-policy')
  console.log(varinat_qty,'varinat_qty')
 if(varinat_qty >0){
      inventry_div.style.display = 'block'
      plus_icons.classList.add('In_stock')
      plus_icons.classList.remove('Low_stock')
      plus_icons.classList.remove('Out_of_stock')
      inventry_span.innerText = `In Stock (${varinat_qty})`
  }else{
      inventry_div.style.display = 'none'
      plus_icons.classList.add('Out_of_stock')
      plus_icons.classList.remove('Low_stock')
      plus_icons.classList.remove('In_stock')
      inventry_span.innerText = `Out of Stock (${varinat_qty})`
  }
  
 
  const request = await fetch("https://ipinfo.io/json")
  const jsonResponse = await request.json()
  if(varinat_qty>0){
   function addCalendarDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
   }    
    const today = new Date();
    const startDate = addCalendarDays(today, 7); 
    const endDate = addCalendarDays(today, 14);  
    const options = { month: 'short', day: 'numeric' };
    const startStr = startDate.toLocaleDateString(undefined, options);
    const endStr = endDate.toLocaleDateString(undefined, options);    
    document.querySelector('.product_shiping_bar').innerHTML =`<span role="label">Estimated delivery:</span> <span>To ${jsonResponse.region} ${jsonResponse.postal} ${startStr} - ${endStr}</span>`;
    $('pickup-availability.product__pickup-availabilities.no-js-hidden').show()
   document.querySelector('.custom_order').innerHTML =` <span role="label">In Stock:</span><span> Ships Immediately</span>`;
  }else if(varinat_qty<= 0){
    // Check for upcoming inventory data
    const upcomingInventoryElement = document.querySelector('.upcoming-inventory-data-element');
    let upcomingInventoryDate = null;
    
    if (upcomingInventoryElement) {
      const upcomingInventoryData = upcomingInventoryElement.getAttribute('data-upcoming-inventory') || '';
      
      if (upcomingInventoryData) {
        // Parse the data: format is "variant_id::date,variant_id::date,"
        const entries = upcomingInventoryData.split(',').filter(entry => entry.trim() !== '');
        
        for (let entry of entries) {
          const [variantId, arrivalDate] = entry.split('::');
          if (variantId && arrivalDate && parseInt(variantId) === id) {
            const arrivalDateObj = new Date(arrivalDate.trim());
            
            // Check if the date is valid
            if (!isNaN(arrivalDateObj.getTime())) {
              // Normalize dates to start of day for accurate comparison
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const arrivalDateNormalized = new Date(arrivalDateObj);
              arrivalDateNormalized.setHours(0, 0, 0, 0);
              
              // Check if the date hasn't passed
              if (arrivalDateNormalized >= today) {
                upcomingInventoryDate = arrivalDateObj;
                break;
              }
            }
          }
        }
      }
    }
    
    function addWeeks(date, weeks) {
      const result = new Date(date);
      result.setDate(result.getDate() + weeks * 7);
      return result;
    }
    
    const today = new Date();
    let startDate, endDate;
    let weeksLeft = null;
    
    if (upcomingInventoryDate) {
      // Calculate: 2-4 weeks from the arrival date
      // Starting from the arrival date, add 2-4 weeks
      const baseDate = new Date(upcomingInventoryDate);
      startDate = addWeeks(baseDate, 2);
      endDate = addWeeks(baseDate, 4);
      
      // Calculate weeks left until arrival
      const todayNormalized = new Date(today);
      todayNormalized.setHours(0, 0, 0, 0);
      const arrivalDateNormalized = new Date(upcomingInventoryDate);
      arrivalDateNormalized.setHours(0, 0, 0, 0);
      
      const diffTime = arrivalDateNormalized - todayNormalized;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      // Round up to nearest week, minimum 1 week
      weeksLeft = Math.max(1, Math.ceil(diffDays / 7));
    } else {
      // Default: 12-14 weeks (made to order)
      startDate = addWeeks(today, 12);
      endDate = addWeeks(today, 14);
    }
    
    const options = { month: 'short', day: 'numeric' };
    const startStr = startDate.toLocaleDateString(undefined, options);
    const endStr = endDate.toLocaleDateString(undefined, options);
    document.querySelector('.product_shiping_bar').innerHTML =`<span role="label">Estimated delivery:</span> <span>To ${jsonResponse.region} ${jsonResponse.postal} ${startStr} - ${endStr}</span>`;
    $('pickup-availability.product__pickup-availabilities.no-js-hidden').hide()
    
    // Update custom_order text based on whether there's upcoming inventory
    if (weeksLeft !== null) {
      document.querySelector('.custom_order').innerHTML =` <span role="label">Available Soon:</span><span> On Route to Studio</span>`;
    } else {
      document.querySelector('.custom_order').innerHTML =` <span role="label">Availability:</span><span> Made to Order</span>`;
    }
  }else{
    document.querySelector('.product_shiping_bar').innerHTML =``;
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  let default_id = parseInt($('form[data-type="add-to-cart-form"] input[name="id"]').val())
     change_Shipping_text(default_id) 
  });
